import { render } from "./view-hv-eobasket-new.vue?vue&type=template&id=2312e16e"
import script from "./view-hv-eobasket-new.vue?vue&type=script&setup=true&lang=js"
export * from "./view-hv-eobasket-new.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/e-grid/eosrc-basket/view-hv-eobasket-new.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2312e16e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2312e16e', __exports__)) {
    api.reload('2312e16e', __exports__)
  }
  
  module.hot.accept("./view-hv-eobasket-new.vue?vue&type=template&id=2312e16e", () => {
    api.rerender('2312e16e', render)
  })

}


export default __exports__